import React from 'react';
import { SearchInput } from '../../shared/inputs/search';
import { PathNav } from './pathNav';
import { SearchBar } from './searchBar';
import { ReactComponent as DascoIcon } from './../../../assets/branding/icon.svg';

import styles from './secondaryNav.module.css';
import { UserDetails } from './userDetails';

export const SecondaryNav = () => {
    return <div className={styles.SecondaryNav}>
        <div className={styles.Title}>
            <div className={styles.Icon}><DascoIcon /></div>
            <div className={styles.Label}>Dasco Portal</div>
            {process.env.REACT_APP_APP_ENV !== 'prod' && (
                <div className={styles.DevStatus}>Dev</div>
            )}
        </div>
        <PathNav />
        <SearchBar />
        <UserDetails />
    </div>
}